// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export var environment = {
  production: false,
  webservice: '/webservice/',
  tokencsrf: '',
  tokenauth: '',
  tokenDelegation: '',
  waiting: 2000,

  // url appel iframe calculatrice
  //BOCC_URL: 'http://cc.local',          //local
  //BOCC_URL: 'http://labonnepaie.local.ambin',          //local
  BOCC_URL: 'https://cc.bac.ambin.fr',   //bac a sable
  //BOCC_URL: 'https://cc-preprod.ambin.fr',  //preprod
  //BOCC_URL: 'https://cc-prod.ambin.fr',  //prod

  ODOO_URL: 'https://ids-cobham.ambin.fr',
  
  // COBCAL_URL: 'https://calc.api.evol.cobham-paie.fr',

  tokencalc: '',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
